/**
 * KeyEraseIconContainer component.
 */
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled key erase icon container.
 */
const KeyEraseIconContainer = styled.div<Props>`
  position: relative;
  left: ${7 * Screen.widthRatio}px;
  top: ${5 * Screen.widthRatio}px;
`;

export default KeyEraseIconContainer;
